import { MediaGalleryInterface } from '../../graphql/magento'
import { Maybe } from '../../utils/types'

export interface MagentoProductImage {
  url: NonNullable<MediaGalleryInterface['url']>
  label: MediaGalleryInterface['label']
}

export interface SanityProductImageSelection {
  alt?: string | null | undefined
  asset: {
    _id: string
  }
}

/** Support images from either Magento or Sanity for now (backwards compatibility/transition) */
export type SanityOrMagentoProductImage = SanityProductImageSelection | MagentoProductImage

export interface SanityProductImagesHierarchy {
  parent: {
    mainImage: SanityProductImageSelection | null | undefined
    // NOTE: Sanity does not currently define other images for parent
  }
  children: ReadonlyMap<string, SanityProductImages>
}

export interface SanityProductImages {
  mainImage: SanityProductImageSelection | null | undefined
  otherImages: ReadonlyArray<SanityProductImageSelection>
}

/**
 * Generic type guard for narrowing query selection to Sanity image with asset._id
 */
export function isSanityImageWithAssetId<
  T extends Maybe<{ asset?: Maybe<{ _id?: Maybe<string> }> }>,
>(image: T): image is NonNullable<T> & { asset: { _id: string } } {
  if (image == null) {
    return false
  }
  const partial = image as NonNullable<T> & { asset?: Maybe<{ _id?: Maybe<string> }> }
  return (
    'asset' in partial &&
    partial.asset != null &&
    '_id' in partial.asset &&
    partial.asset._id != null
  )
}

export type SingleSourceOrSourceSet =
  | { _tag: 'SingleSource'; src: string }
  | { _tag: 'SourceSet'; defaultSrc: string; srcSet: string; sizes: string }
